export var EventModes;
(function (EventModes) {
    EventModes[EventModes["Fixture"] = 0] = "Fixture";
    EventModes[EventModes["Outright"] = 99] = "Outright";
    EventModes[EventModes["LiveFixture"] = 1] = "LiveFixture";
    EventModes[EventModes["LiveOutright"] = 199] = "LiveOutright";
})(EventModes || (EventModes = {}));
//# sourceMappingURL=EventModes.js.map